<template>
    <div class='inline-card-cont'>
        <tep-address-nsi-button :meta='props.meta' :server-data='serverData' />
        <tep-av-add-address-btn :meta='props.meta' :server-data='serverData' />
    </div>
</template>

<script setup>
import TepAvAddAddressBtn from '@/views/tep/tep-grid/components/tep-av-add-address-btn.vue';
import TepAddressNsiButton from '@/views/tep/tep-grid/components/tep-address-nsi-button.vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    }
});
</script>

<style scoped>
.inline-card-cont {
    display: flex;
    align-items: center;
}
</style>
